import { gql } from 'graphql-tag';

export const orderNumbersMutation = gql`
mutation necOrderDids($input: [NecOrderDidInput]!) {
  necOrderDids(input: $input) {
    id
    numbers {
      number
      status
      info
    }
    status
    info
    pbxInfo {
      id
      dids {
        did
        numberStatus
        requestedStatus
      }
    }
  }
}
`;


const numbersForServiceFields = `
  id
  numbers {
    id
    did
    status
    info
    orderedAt
    orderId
    orderedByUserId
    orderedByUserName
  }
`;

const numbersForPlatformServiceFields = `
  id
  numbers {
    id
    did
    status
    info
  }
`;

export const numbersForPlatformServiceQuery = gql`
  query numbersForPlatformService($serviceId: ID!) {
    numbersForPlatformService(serviceId: $serviceId) {
      ${numbersForPlatformServiceFields}
    }
  }
`;

export const orderNumbersForServiceMutation = gql`
  mutation orderNumbersForService($input: OrderNumbersForServiceInput!) {
    orderNumbersForService(input: $input) {
      ${numbersForServiceFields}
    }
  }
`;

